import React from "react";
import { Layout, Card, Typography, Select, Steps,Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
export default function FirstStep(props) {
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  const { Step } = Steps;
  const { Option } = Select;
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"))
  return (
    <Card
      style={{ width: 353 }}
      bordered={true}
      className="login-container-steps"
    >
      {" "}
      <div className="logo-container">
      {props.loading ? <Spin/>: <InfoCircleOutlined className="profileInfo1" />}
        <Title strong level={4}>Verify Your Mail</Title>
      </div>
      <div className="Text-container-step">
        <Text>{`Please check your inbox (${loggedUser?.email}) and click on the verification link to verify your email.`}</Text>
      </div>
    </Card>
  );
}
